import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowRight } from "lucide-react";
import { api } from "../lib/api";

export default function Courts() {
  const [courts, setCourts] = useState([]);
  useEffect(() => {
    api.get("/courts").then((r) => setCourts(r.data)).catch(() => {});
  }, []);

  return (
    <main className="max-w-7xl mx-auto px-6 lg:px-10 py-20" data-testid="courts-page">
      <motion.div initial={{ opacity: 0, y: 24 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.6 }}>
        <p className="text-[#ccff00] uppercase tracking-[0.3em] text-sm mb-4">Our Courts</p>
        <h1 className="font-display uppercase text-4xl sm:text-5xl lg:text-6xl tracking-tight max-w-3xl">
          Six surfaces. <span className="text-[#ccff00]">Zero excuses.</span>
        </h1>
        <p className="text-white/60 max-w-xl mt-6 leading-relaxed">
          From tournament-spec indoor hard to true championship grass. Pick your battlefield and book a slot — every booking is a free demo.
        </p>
      </motion.div>

      <div className="grid grid-cols-1 md:grid-cols-12 gap-8 mt-16">
        {courts.map((c, i) => (
          <motion.div
            key={c.id}
            initial={{ opacity: 0, y: 24 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.5, delay: (i % 3) * 0.1 }}
            className={i % 3 === 0 ? "md:col-span-7" : i % 3 === 1 ? "md:col-span-5" : "md:col-span-6"}
          >
            <Link
              to={`/courts/${c.id}`}
              data-testid={`court-card-${c.id}`}
              className="group block relative rounded-md overflow-hidden border border-[#2a2a2a] hover:border-[#ccff00]/50 transition-colors duration-300 h-[340px]"
            >
              <img src={c.image} alt={c.name} className="absolute inset-0 w-full h-full object-cover group-hover:scale-105 transition-transform duration-700" />
              <div className="absolute inset-0 bg-black/50 group-hover:bg-black/40 transition-colors duration-300" />
              <div className="absolute top-6 left-6 flex gap-2">
                <span className="text-[11px] uppercase tracking-widest bg-black/70 backdrop-blur px-3 py-1.5 rounded-full border border-white/15">{c.type}</span>
                <span className="text-[11px] uppercase tracking-widest bg-[#ccff00] text-black font-bold px-3 py-1.5 rounded-full">${c.price}/hr</span>
              </div>
              <div className="absolute bottom-0 p-6 w-full">
                <p className="text-white/60 text-xs uppercase tracking-widest mb-1">{c.surface}</p>
                <h2 className="font-display uppercase text-3xl tracking-tight">{c.name}</h2>
                <p className="text-white/70 mt-2 text-sm max-w-md">{c.tagline}</p>
                <span className="text-[#ccff00] text-sm uppercase tracking-widest inline-flex items-center gap-2 mt-4 group-hover:gap-3 transition-[gap] duration-200">
                  View & book <ArrowRight size={14} />
                </span>
              </div>
            </Link>
          </motion.div>
        ))}
      </div>
    </main>
  );
}
